export const productFontSizes = {
  // #DESIGN_2023
  '2xs': '0.625rem', // 10px
  xs: '0.75rem', // 12px
  sm: '0.875rem', // 14px
  md: '1rem', // 16px
  lg: '1.1875rem', // 19px
  xl: '1.4375rem', // 23px
  '2xl': '1.75rem', // 28px
  '3xl': '2.0625rem', // 33px
  '4xl': '2.5rem', // 40px
}

export const fontSizes = {
  product: productFontSizes,
}
